// /api/plan/list - список тарифов
// /api/plan/current - текущий тариф юзера
// /api/plan/pay - покупка тарифа/опции, пополнение баланса

import { TOption } from "../typings/UserPlan";
import http from "./client";


async function list() {
  const res = await http.get('/api/plan/list');

  return res.data;
}
async function current() {
  const res = await http.get('/api/plan/current');

  return res.data;
}
export interface IUserBuyParams {
  "type": 'refill'| 'plan'| 'option'
  "id"?: string, // id тарифа или опции, не нужен при пополнении баланса
  "period": number,
  "cost": number, // сумма пополнения баланса
  "use_balance" : boolean // оплата с баланса
  count?: number,
}
async function pay(params: IUserBuyParams) {
  const res = await http.post("/api/plan/pay", params);
  return res.data;
}


async function prolongOption(params: IUserBuyParams) {
  const res = await http.post('/api/plan/prolong', params);
  return res.data
}

async function canProlongOption(id: TOption['id']) {
  const res = await http.get('/api/plan/prolong', {
    params: {
      id
    }
  });

  return res.data;
}

async function renewOption(params: {key: string, period: number, use_balance: boolean}) {
  const res = await http.post('/api/plan/renewal', params);

  return res.data;
}

const plan = {
  pay, current, list, canProlongOption, prolongOption, renewOption,
}

export default plan;